import {LocalStorage} from 'wize-admin'
import {BusinessService} from "@/core/services";


const state = {
  menuOpen: true,
  currentSubmenu: localStorage.getItem('currentSubmenu') === null ? [] : localStorage.getItem('currentSubmenu').split(','),
  loading: false,
  currentDevice: null,
  business: LocalStorage.getBusiness() ? JSON.parse(LocalStorage.getBusiness()) : null,
  businesses: [],
  availableDate: null,
  startDate: null,
  lastClosedDate: null,
  showViewAdmin: false
};

const getters = {
  getCurrentSubmenu: state => state.currentSubmenu,
  isMenuOpen : state=> state.menuOpen,
  isLoading: state => state.loading,
  getCurrentDevice: (state) => state.currentDevice,
  getShowViewAdmin: state => {
    return state.showViewAdmin;
  },
  getAvailableDate: state => {
    return state.availableDate
  },
  getStartDate: state => {
    return state.startDate;
  },
  getLastClosedDate: state => {
    return state.lastClosedDate;
  },
  getBusiness: state => {
    return state.business;
  },
  getBusinesses: state => {
    return state.businesses;
  }
};

const actions = {
  loading: (store, val) => {
    store.commit('setLoading', val)
  },
  loadStartupData: ({dispatch}) => {
    return new Promise((resolve) => {
      dispatch('loadBusinesses')
      .then(() => resolve())

    });
  },
  loadLastClosedDate: ({commit}) => {
    return new Promise((resolve, reject) => {
      BusinessService.getLastClosedDate().then(
        response => {
          if (response.payload)
            commit('lastClosedDate', response.payload)
          else
            commit('lastClosedDate', {})
          resolve()
        }
      ).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  },
  loadBusinesses: ({commit}) => {
    return new Promise((resolve, reject) => {
      BusinessService.list().then(
        response => {
          if (response.payload)
            commit('businesses', response.payload)
          else
            commit('businesses', {})
          resolve()
        }
      ).catch((error) => {
        console.error(error);
        reject(error);
      })
    });
  }
};

const mutations = {
  setCurrentSubmenu(state, value) {
      const values = state.currentSubmenu
      state.currentSubmenu = values.includes(value)?  values.filter(e => e !== value) : [...values, value]
      localStorage.setItem('currentSubmenu', state.currentSubmenu)
  },
  toggleMenu(state, value) {
    state.menuOpen = value
  },
  setMenu(state, value) {
    state.menuOpen = value
  },
  setLoading(state, value) {
    state.loading = value
  },
  setCurrentDevice(state, value) {
    state.currentDevice = value;
  },
  setShowViewAdmin(state, value) {
    state.showViewAdmin = value;
  },
  availableDate(state, value) {
    state.availableDate = value;
  },
  startDate(state, value) {
    state.startDate = value;
  },
  lastClosedDate(state, value) {
    state.lastClosedDate = value;
  },
  businesses(state, value) {
    if (value && value.length > 0 && !state.business) {
      state.business = value[0];
      LocalStorage.setBusiness(value[0]);
    }

    state.businesses = value;
  },
  business(state, value) {
    value ? LocalStorage.setBusiness(value) : LocalStorage.clearBusiness();
    state.business = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}